import avatar1 from '../../../Assets/characters/person1.jpg';
import avatar2 from '../../../Assets/characters/person2.jpg';
import avatar3 from '../../../Assets/characters/person3.jpg';
import avatar4 from '../../../Assets/characters/person4.jpg';
import avatar5 from '../../../Assets/characters/person5.jpg';
import avatar6 from '../../../Assets/characters/person6.jpg';
import avatar7 from '../../../Assets/characters/person7.jpg';
import avatar8 from '../../../Assets/characters/person8.jpg';
import avatar9 from '../../../Assets/characters/person9.jpg';
import avatar10 from '../../../Assets/characters/person10.jpg';
import defaultAvatar from '../../../Assets/characters/default.jpg';

export const Characters = [
    {
        id: 1,
        img: defaultAvatar,
    },
    {
        id: 2,
        img: avatar1,
    },
    {
        id: 3,
        img: avatar2,
    },
    {
        id: 4,
        img: avatar3,
    },
    {
        id: 5,
        img: avatar4,
    },
    {
        id: 6,
        img: avatar5,
    },
    {
        id: 7,
        img: avatar6,
    },
    {
        id: 8,
        img: avatar7,
    },
    {
        id: 9,
        img: avatar8,
    },
    {
        id: 10,
        img: avatar9,
    },
    {
        id: 11,
        img: avatar10,
    }

]